{
  "login": {
    "button_login": "登入",
    "logout_successful": "登出成功",
    "remember_me": "記住我",
    "error": {
      "login_required": "需要登入才能存取此資源 <em>(錯誤：{code})</em>。",
      "invalid_username_or_password": "無效的使用者名稱或密碼"
    },
    "placeholder": {
      "username": "使用者名稱",
      "password": "密碼"
    }
  }
}
